<template>
<el-dialog :visible.sync="show" title="导入删除" width="410px">
  <div class="content">
    <div style="padding-bottom: 12px;">
      <el-button type="text" @click="downloadTemp">导入模版</el-button>
    </div> 
    <div class="upload-wrap">
      <el-upload
        class="upload-demo"
        drag
        accept=".xls, .xlsx"
        :limit="1"
        :auto-upload="false"
        :file-list="fileList"
        :on-change="handleUploadChange"
        :on-remove="() => fileList = []"
        ref="upload"
        action="#">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">点击或拖拽上传文件</div>
        <div class="el-upload__tip" slot="tip">请先下载导入模版，填入数据后，再进行订单上传 <br />
          数量1，大小2M以内，支持格式xls,xlsx</div>
      </el-upload>
    </div>
  </div>
  <!-- 导入结果 -->
  <el-dialog :visible.sync="showRstDialog" append-to-body title="导入结果" width="410px">
    <div v-if="importRst">
      总上报{{ (importRst.successNum || 0) + (importRst.failNum || 0)}}条，已删除{{ importRst.successNum }}条，{{ importRst.failNum }}不存在
    </div>
    <div slot="footer">
      <el-button size="mini" @click="showRstDialog = false">关闭</el-button>
      <el-button size="mini" @click="exportExcel"  type="primary">导出结果表</el-button>
    </div>
  </el-dialog>
  
  <div slot="footer">
    <el-button size="mini" @click="$emit('close')">关闭</el-button>
    <el-button size="mini" :disabled="!fileList.length" @click="submitUpload" type="primary">上传</el-button>
  </div>
</el-dialog>
</template>

<script>
import { getUserId } from '@/utils/getUser'
import { importDelete } from '@/service/apis/order'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
const dayjs = require('dayjs')

export default {
  name: 'importExportDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    }, 
    roleType: {
      type: Number,
      default: null
    }
  }, 
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  data () {
    return {
      form: {
        qdAccountId0: '',
        qdAccountId: ''
      },
      fileList: [],
      showRstDialog: false,
      importRst: null
    }
  },
  watch: {
  },
  methods: {

    exportExcel () {
      const heads = ['订单编号', '结果']
      const baseKeys = []
      
      const data = [
        [...heads]
      ]
      const successList = this.importRst.successList || []
      const failList = this.importRst.failList || []
      successList.forEach(item => {
        data.push([{ t: 's', v: item }, '成功'])
      })
      failList.forEach(item => {
        data.push([{ t: 's', v: item }, '失败'])
      })

      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data)

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })

      // 使用blob和FileReader创建一个URL然后下载
      const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' })
      // 
      saveAs(dataBlob, `导入结果 ${dayjs().format('YYYYMMDDHHmmss')}.xlsx`)
    },
    downloadTemp () {
      window.open(location.origin + '/template/OrderTemplate.xlsx')
    },
    handleUploadChange (file) {
      this.fileList = [file]
    },
    submitUpload() {
      this.$confirm('该操作无法撤回，确定要执行导入删除吗？', '提示', {
        type: 'warning',
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then(() => {
        this.handleUpload()
      })
    },
    closeRstDialog () {
      this.showRstDialog = false
    },
    // 上传excel
    handleUpload () {
      if (!this.fileList.length) return
      const file = this.fileList[0]
      const { size } = file;
      if (size / 1024 / 1024 > 2) {
        this.$message.error('上传文件的大小不能超过2MB')
        this.fileList = []
        return false
      } 
      const opt = {
        accountId: getUserId()
      } 
      const loading = this.$loading({
        lock: true,
        text: '导入中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.45)'
      })
      try {
        importDelete.call(this, file.raw, opt).then(resp => {
          if (resp) {
            // 清空选择文件
            this.fileList = []
            // this.$emit('on-success', resp)
            this.importRst = resp
            this.showRstDialog = true
          }
        }).finally(() => {
          loading.close()
        })
      } catch (e) {
        console.error(e)
      }
    }
  }
}
</script>

<style scoped>
.content { 
  line-height: 24px;
  font-size: 14px;
  color: #666;
}
.flex-row {
  line-height: 30px;
}
.upload-wrap {
  padding-top: 16px;
}
</style>
